<template>
  <div class="wrapper">
    <header-title title="التعاميم " titlePrevious="الرئيسية" color="#164e63" />
    <div class="container">
      <b-row class="my-5 mx-1">
        <b-col cols="12" md="7">
          <h6 class="font-weight-bolder font-screen-small">
            <feather-icon icon="InfoIcon" size="20" /> الرجاء إختيار نوع التعميم
            لعرض كافة التعاميم الخاصة به
          </h6>
        </b-col>
        <b-col cols="12" md="5">
          <div class="shadow rounded">
            <b-input-group class="input-group-merge" style="">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                placeholder="البحث عن نوع التعميم"
                type="text"
                v-model="filtred"
              />
            </b-input-group>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="loading">
        <b-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="n">
          <b-skeleton width="100%" height="100px"></b-skeleton>
        </b-col>
      </b-row>
      <template v-else>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="(circular, i) in typeCirclars"
            :key="i"
          >
            <Circular
              :id="circular.id"
              :name="circular.name_ar"
              class="my-1"
              :isDecisions="false"
            ></Circular>
          </b-col>
        </b-row>
      </template>
      <alert
        v-if="typeCirclars.length == 0 && !loading"
        class="w-100"
        :massage="$t('alert')"
      ></alert>

      <pagination
        v-model="currentPage"
        :total-rows="pagination.total_row"
        :per-page="8"
        align="center"
        class="my-4"
      />
    </div>
  </div>
</template>

<script>
import {
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BPaginationNav,
  BSkeleton,
  BRow,
  BCol,
} from "bootstrap-vue";
import Circular from "../../../components/Circular.vue";
import Pagination from "@/components/pagination";
import HeaderTitle from "../../../components/HeaderTitle.vue";
import { mapActions, mapGetters } from "vuex";
import debounce from "lodash.debounce";
import Alert from "@/components/Alert.vue";

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    Circular,
    HeaderTitle,
    BPaginationNav,
    BSkeleton,
    BRow,
    BCol,
    Pagination,
    Alert,
  },
  data() {
    return {
      currentPage: 1,
      currentArray: [],
      filtred: null,
    };
  },
  methods: {
    ...mapActions("NgoHome/Circulars", ["getTypeCirclars"]),
  },

  computed: {
    ...mapGetters("NgoHome/Circulars", [
      "typeCirclars",
      "loading",
      "pagination",
    ]),
  },

  watch: {
    filtred: debounce(function (value) {
      this.currentPage = 1;
      this.getTypeCirclars({ page: this.currentPage, name: this.filtred });
    }, 500),

    currentPage(value) {
      this.getTypeCirclars({ page: value, name: this.filtred });
    },
  },

  created() {
    this.getTypeCirclars({ page: this.currentPage, name: this.filtred });
  },
};
</script>

<style scoped>
@media (max-width: 630px) {
  /* .circular_small {
    display: flex;
    flex-direction: column;
    justify-content: center;
  } */

  .font-screen-small {
    font-size: 1rem;
    margin-bottom: 20px;
  }
  .title {
    font-size: 25px;
  }
}
</style>
